import styled, { CSSObject } from 'styled-components';
import { Cell } from 'styled-css-grid';

import { colors } from '@crm-framework/theme';

export const Page = styled.div.attrs({
  className: 'page',
})<{ isCollapsedSidebar?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: ${({ isCollapsedSidebar }) =>
    isCollapsedSidebar ? '100%' : 'fit-content'};
  min-width: 100%;
`;

export const Header = styled.div.attrs({
  className: 'header',
})`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 40px;
  padding: 5px 20px;
  font-weight: 600;
  background: ${colors.N1};
  color: ${colors.HEADING};
  box-shadow: inset 0px -1px 5px 0px rgba(0, 0, 0, 0.1);
`;

export const HeaderName = styled.h2.attrs({
  className: 'header-name',
})`
  margin: 0;
  font-weight: 600;
  align-self: center;
`;

export const Content = styled.div.attrs({
  className: 'page-content',
})<{ contentStyles?: CSSObject }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  width: 100%;
  min-width: 100%;
  ${({ contentStyles }) => contentStyles};
`;

export const EnvironmentsWrapper = styled.div.attrs({
  className: 'environments',
})`
  background-color: ${colors.SECONDARY};
  padding: 15px;
`;

export const EnvironmentsHeaderName = styled.h2.attrs({
  className: 'environments__header',
})`
  padding-left: 15px;
  margin: 0 0 20px;
  color: ${colors.WHITE};
`;

export const TimeWrapper = styled.span.attrs({
  className: 'time-wrapper',
})`
  margin: 0;
  align-self: center;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  width: max-content;
  margin: 0 0 0 auto;
`;

export const DateText = styled.div`
  font-weight: 400;
  margin: 0 7px;
`;

export const SidebarCell = styled(Cell)`
  z-index: 99;
`;
